module.exports = __webpack_public_path__ + "static/media/logo-small.26a6ad7a.svg";